import React, { useEffect } from "react";
import "./cta-button.css";

const CTAButton = () => {
  useEffect(() => {
    // Create animated particles
    const particlesContainer = document.getElementById("tims-particles");
    const particleCount = 50;
    for (let i = 0; i < particleCount; i++) {
      const particle = document.createElement("div");
      particle.className = "tims-particle";
      particle.style.left = Math.random() * 100 + "%";
      particle.style.top = Math.random() * 100 + "%";
      particle.style.animationDelay = Math.random() * 6 + "s";
      particle.style.animationDuration = Math.random() * 4 + 4 + "s";
      particlesContainer.appendChild(particle);
    }



// Intersection Observer for feature cards fade in up
    const observerOptions = {
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px",
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.animation = "tims-fadeInUp 0.6s ease forwards";
        }
      });
    }, observerOptions);

    document.querySelectorAll(".tims-feature-card").forEach((card, index) => {
      card.style.opacity = "0";
      card.style.transform = "translateY(30px)";
      card.style.animationDelay = `${index * 0.1}s`;
      observer.observe(card);
    });

    // Cleanup event listeners on unmount - optional here as no dependencies
  }, []);

  return (
    <>
      {/* <div className="tims-floating-shapes">
        <div className="tims-shape tims-shape-1"></div>
        <div className="tims-shape tims-shape-2"></div>
        <div className="tims-shape tims-shape-3"></div>
      </div> */}

      <div className="tims-particles" id="tims-particles"></div>

      <div className="">
        <div className="tims-mobile-static-buttons">
          <button
            className="tims-cta-static-button tims-pulse"
            onClick={() => window.dispatchEvent(new CustomEvent("tims:openBrochure"))}
          >
            📥 Download Brochure
          </button>
        </div>

        <div className="tims-cta-container">
          <div
            className="tims-cta-button tims-apply"
            tabIndex={0}
            onClick={() => window.dispatchEvent(new CustomEvent("tims:openEnquiry"))}
            onKeyDown={(e) => e.key === "Enter" && window.dispatchEvent(new CustomEvent("tims:openEnquiry"))}
          >
            <span className="tims-icon">
              <img src="/Website_Assets/Enquire Now.svg" alt="" width="20" height="20" />
            </span>
            <span className="tims-text">Enquire Now</span>
          </div>

          <a className="tims-cta-button tims-phone" href="tel:+919594965066" tabIndex={0} aria-label="Call Us">
            <span className="tims-icon" aria-hidden="true">
              <img src="/Website_Assets/Call.svg" alt="" width="20" height="20" />
            </span>
            <span className="tims-text">Call Us</span>
          </a>

          <a className="tims-cta-button tims-email" href="mailto:timscdr@thakureducation.org" tabIndex={0}>
            <span className="tims-icon">
              <img src="/Website_Assets/Mail.svg" alt="" width="20" height="20" />
            </span>
            <span className="tims-text">Email Us</span>
          </a>

          <a className="tims-cta-button tims-linkedin" href="https://www.linkedin.com/school/68346164/" target="_blank" rel="noreferrer" tabIndex={0}>
            <span className="tims-icon">
              <img src="/Website_Assets/LinkedIn.svg" alt="" width="20" height="20" />
            </span>
            <span className="tims-text">LinkedIn</span>
          </a>

          <a className="tims-cta-button tims-instagram" href="https://www.instagram.com/timscdr.official/" target="_blank" rel="noreferrer" tabIndex={0}>
            <span className="tims-icon">
              <img src="/Website_Assets/Instagram.svg" alt="" width="20" height="20" />
            </span>
            <span className="tims-text">Instagram</span>
          </a>

          <a className="tims-cta-button tims-facebook" href="https://www.facebook.com/thakur.mca.1" target="_blank" rel="noreferrer" tabIndex={0}>
            <span className="tims-icon">
              <img src="/Website_Assets/Facebook.svg" alt="" width="20" height="20" />
            </span>
            <span className="tims-text">Facebook</span>
          </a>
        </div>
      </div>
    </>
  );
};

export default CTAButton;
